module.exports = __webpack_public_path__ + "img/notice-sub2.63c53b21.png";